import { render, staticRenderFns } from "./customizedDetail.vue?vue&type=template&id=1560a4d8&scoped=true&"
import script from "./customizedDetail.vue?vue&type=script&lang=js&"
export * from "./customizedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560a4d8",
  null
  
)

export default component.exports